module.exports = __webpack_public_path__ + "img/插画-评估报告@2x.fef3e867.png";